module.exports = __webpack_public_path__ + "static/1732685807992/media/question-icon.cd0a7c30.svg";